export const categorySlugMap = {
  "صندل زنانه": "women-sandals",
  "کفش مجلسی": "women-formal-shoes",
  "کفش پرسنلی": "women-work-shoes",
  "اسپورت": "women-sport-shoes",
  "کتانی": "women-sneakers",
  "صندل روفرشی": "women-indoor-sandals"
};

export const legacyCategorySlugMap = {
  "formal-shoes": "women-formal-shoes",
  "work-shoes": "women-work-shoes",
  "sport-shoes": "women-sport-shoes",
  "sandals": "women-sandals"
};

export const categoryNameMap = Object.fromEntries(
  Object.entries(categorySlugMap).map(([name, slug]) => [slug, name])
);

export const safeCategorySlug = (value) => {
  const text = String(value || "").trim();

  if (!text) return "";

  if (categorySlugMap[text]) return categorySlugMap[text];
  if (legacyCategorySlugMap[text]) return legacyCategorySlugMap[text];

  return text
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9\u0600-\u06FF]+/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const categoryDisplayName = (value) => {
  const text = String(value || "").trim();
  const canonical = legacyCategorySlugMap[text] || text;

  return categoryNameMap[canonical] || text;
};

export const categoryUrl = (categoryOrSlug, page = null) => {
  const raw = typeof categoryOrSlug === "object"
    ? categoryOrSlug?.canonical_slug || categoryOrSlug?.slug || categoryOrSlug?.name
    : categoryOrSlug;

  const slug = safeCategorySlug(raw);

  if (!slug) return "/products";

  return page ? `/category/${slug}/${page}` : `/category/${slug}`;
};
